import * as Types from '../../../gql/base-types';

import { gql } from '@apollo/client';
import * as Apollo from '@apollo/client';

// =============================================================================
// Auto-generated by GraphQL Codegen - DO NOT EDIT
// Change the .gql source (or the schema) and re-run: pnpm codegen
// =============================================================================

const defaultOptions = {} as const;
export type ReinstateUserMutationVariables = Types.Exact<{
  userId: Types.Scalars['bigint']['input'];
}>;


export type ReinstateUserMutation = { __typename?: 'mutation_root', update_users?: { __typename?: 'users_mutation_response', affected_rows: number, returning: Array<{ __typename?: 'users', id: number, active: boolean }> } | null };


export const ReinstateUserDocument = gql`
    mutation reinstateUser($userId: bigint!) {
  update_users(where: {id: {_eq: $userId}}, _set: {active: true}) {
    affected_rows
    returning {
      id
      active
    }
  }
}
    `;
export type ReinstateUserMutationFn = Apollo.MutationFunction<ReinstateUserMutation, ReinstateUserMutationVariables>;

/**
 * __useReinstateUserMutation__
 *
 * To run a mutation, you first call `useReinstateUserMutation` within a React component and pass it any options that fit your needs.
 * When your component renders, `useReinstateUserMutation` returns a tuple that includes:
 * - A mutate function that you can call at any time to execute the mutation
 * - An object with fields that represent the current status of the mutation's execution
 *
 * @param baseOptions options that will be passed into the mutation, supported options are listed on: https://www.apollographql.com/docs/react/api/react-hooks/#options-2;
 *
 * @example
 * const [reinstateUserMutation, { data, loading, error }] = useReinstateUserMutation({
 *   variables: {
 *      userId: // value for 'userId'
 *   },
 * });
 */
export function useReinstateUserMutation(baseOptions?: Apollo.MutationHookOptions<ReinstateUserMutation, ReinstateUserMutationVariables>) {
        const options = {...defaultOptions, ...baseOptions}
        return Apollo.useMutation<ReinstateUserMutation, ReinstateUserMutationVariables>(ReinstateUserDocument, options);
      }
export type ReinstateUserMutationHookResult = ReturnType<typeof useReinstateUserMutation>;
export type ReinstateUserMutationResult = Apollo.MutationResult<ReinstateUserMutation>;
export type ReinstateUserMutationOptions = Apollo.BaseMutationOptions<ReinstateUserMutation, ReinstateUserMutationVariables>;
import { resolveExecutor, type GqlExecutor, type GqlRequestOptions } from '@hopdrive/sdk-core'


/**
 * @source {@link src/features/userManagement/queries/reinstateUser.mutation.gql}
 */
export async function reinstateUser(
  variables: ReinstateUserMutationVariables,
  options?: { executor?: GqlExecutor; raw?: false } & GqlRequestOptions
): Promise<ReinstateUserMutation['update_users']>
export async function reinstateUser(
  variables: ReinstateUserMutationVariables,
  options?: { executor?: GqlExecutor; raw: true } & GqlRequestOptions
): Promise<ReinstateUserMutation>
export async function reinstateUser(
  variables: ReinstateUserMutationVariables,
  options?: { executor?: GqlExecutor; raw?: boolean } & GqlRequestOptions
): Promise<ReinstateUserMutation['update_users'] | ReinstateUserMutation> {
  const { executor, raw, ...requestOptions } = options ?? {}
  const result = await resolveExecutor(executor).mutate<ReinstateUserMutation>(
    ReinstateUserDocument,
    variables,
    requestOptions
  )
  if (raw) return result
  return result.update_users
}